import { HealthResource, PostMessageType } from '@abiglobalhealth/go-types'
import { MouseEvent } from 'react'

import { OpenLinkIcon } from '@/components/icons/OpenLinkIcon'
import useNavigator from '@/hooks/useNavigator'
import { usePostMessage } from '@/hooks/usePostMessage'

export const HealthResourceButton = ({ resource }: { resource: HealthResource }) => {
  const url = new URL(resource.url)

  const { sendPostMessage } = usePostMessage()
  const { navigator } = useNavigator()

  const handleClick = async (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()

    await sendPostMessage(PostMessageType.NAVIGATOR_HEALTH_RESOURCE_CLICK, {
      ...resource,
      conversationId: navigator.healthNavigator.conversationId!
    })

    window.open(resource.url, '_blank', 'noopener,noreferrer')
  }

  return (
    <a
      href={resource.url}
      target="_blank"
      rel="noreferrer"
      className="flex items-center gap-8 rounded-[10px] bg-[#f7f7f7] px-4 py-3"
      onClick={handleClick}
    >
      <div className="flex grow flex-col gap-2">
        <p className="font-bold">{resource.name}</p>
        <p className="text-gray-text">{url.hostname}</p>
      </div>

      <span className="w-4">
        <OpenLinkIcon className="text-primary h-4 w-4" />
      </span>
    </a>
  )
}
